import { Children } from "react";
import PropTypes from "prop-types";
import * as AriaKit from "@ariakit/react";

function Tabs({ defaultSelectedId, children, onChange, selected }) {
  const onTabClick = (tabHref, id) => {
    if (tabHref) {
      const currentUrl = new URL(window.location.href);
      const newParams = new URLSearchParams(tabHref);
      newParams.forEach((value, key) => {
        currentUrl.searchParams.set(key, value);
      });
      window.history.replaceState(null, "", currentUrl);
    }

    if (onChange) {
      onChange(id);
    }
  };

  return (
    <AriaKit.TabProvider defaultSelectedId={selected ?? defaultSelectedId}>
      <div className="qpp-c-tabs qpp-c-tabs--mui">
        <AriaKit.TabList aria-label="qpp tabs">
          {Children.map(children, (child) => (
            <AriaKit.Tab
              key={child.props.id}
              id={child.props.id}
              className="qpp-c-tabs__item"
              disabled={child.props.disabled}
              onClick={() => onTabClick(child.props.tabHref, child.props.id)}
            >
              {child.props.tab}
            </AriaKit.Tab>
          ))}
        </AriaKit.TabList>
      </div>
      <div className="qpp-c-tabs__panel">
        {Children.map(children, (child) => (
          <AriaKit.TabPanel
            key={child.props.id}
            tabId={child.props.id}
            className={child.props.className}
            disabled={child.props.disabled}
          >
            {child.props.children}
          </AriaKit.TabPanel>
        ))}
      </div>
    </AriaKit.TabProvider>
  );
}

Tabs.propTypes = {
  defaultSelectedId: PropTypes.string,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  selected: PropTypes.string,
};

export default Tabs;
